export default __webpack_public_path__ + "static/media/Animals-01.ed554ff4.png";